/**
 * rsa-hero-2026 block
 *
 * Dark rounded hero for the RSA 2026 landing page.
 * Dark background, centered title, subtitle, and centered illustration.
 * Line breaks authored in YAML render as <br/>.
 */
export function RsaHero2026({
  heading,
  subheading,
  image,
  image_alt,
}: {
  heading?: string;
  subheading?: string;
  image?: string;
  image_alt?: string;
}) {
  const hasImage = Boolean(image);
  // When a hero image is present, let it sit flush against the bottom edge
  // of the rounded container instead of leaving a large padding gap.
  const containerPadding = hasImage
    ? "px-6 pt-10 pb-0 md:px-12 md:pt-14 lg:pt-16"
    : "px-6 py-10 md:px-12 md:py-14 lg:py-16";
  return (
    <div className="px-4 md:px-8 pt-8 lg:pt-10">
      <div className="max-w-screen-xl mx-auto">
        <div className={`bg-blue-90 rounded-2xl overflow-hidden ${containerPadding}`}>
          <div className="relative max-w-4xl mx-auto text-center">
            {heading && (
              <h1
                className="font-display text-white font-bold text-3xl sm:text-4xl lg:text-5xl leading-tight"
                dangerouslySetInnerHTML={{ __html: heading }}
              />
            )}
            {subheading && (
              <p className="font-body text-white/80 text-lg md:text-xl mt-6">
                {subheading}
              </p>
            )}
            {image && (
              <div className="mt-6 lg:mt-10 flex justify-center">
                <img
                  src={image}
                  alt={image_alt || ""}
                  className="max-w-full w-full max-w-3xl block"
                  loading="lazy"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
